import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let _cache = null, _at = 0, _inflight = null;

export const loadDailyWish = () => {
  if (_cache !== null && Date.now() - _at < 15 * 60 * 1000) return Promise.resolve(_cache);
  if (_inflight) return _inflight;
  _inflight = fetch(`${API}/public/daily-wish`)
    .then((r) => (r.status === 200 ? r.json() : r.status === 204 ? false : null))
    .catch(() => null)
    .then((d) => {
      if (d !== null) { _cache = d; _at = Date.now(); }
      _inflight = null;
      return _cache;
    });
  return _inflight;
};

export const useDailyWish = () => {
  const [wish, setWish] = useState(_cache || null);
  useEffect(() => { loadDailyWish().then((d) => setWish(d || null)); }, []);
  return wish;
};
